import React, { useState, useEffect } from "react";
import Axios from "axios";
import moment from "moment";
import "./../../../../assets/css/purchase/form.css";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import ArModal from "../../../components/Modal/ArModal";
import ItemTable from "../../../components/Content/ItemTable";
import Summary from "../../../components/Footer/Summary";
import DatePicker from "../../../components/DatePicker";
import PaymentModal from "../../../components/Modal/PaymentModal";
import FormAction from "../../../components/Actions/FormAction";

// Model
import { qtMasterModel } from "../../../../model/SellProducts/QtMasterModel";
import { qtDetailModel } from "../../../../model/SellProducts/QtDetailModel";

// Utils
import {
  getDataWithComp,
  getByDocId,
  getDocType,
  getTransType,
  getViewItem,
  getAlert,
  formatCurrency,
  parseCurrency,
  deleteData,
  randomDelay,
  getData,
  getSpRunNumber,
  getMaxRecNoForTest,
  createSetRecNo,
  uploadMultipleSlips,
  uploadSlip,
} from "../../../../utils/SamuiUtils";

import {
  convertDate,
  formatDateTime,
  formatThaiDateUiToDate,
  getCreateDateTime,
  setCreateDateTime,
} from "../../../../utils/DateUtils";

import {
  manageWhArPaymentData,
  setRemarkByPaymentType,
} from "../../../../utils/PaymentUtils";
import ViewSoModal from "../../../components/Modal/ViewSoModal";

function Form({ callInitialize, mode, setMode, name, maxDocNo, getReport }) {
  const [formMasterList, setFormMasterList] = useState(qtMasterModel());
  const [formDetailList, setFormDetailList] = useState([]);
  const [tbDocType, setTbDocType] = useState([]);
  const [tbTransType, setTbTransType] = useState([]);
  const [arDataList, setArDataList] = useState([]);
  const [itemDataList, setItemDataList] = useState([]);
  const [whDataList, setWhDataList] = useState([]);

  // การคำนวณเงิน
  const [selectedDiscountValueType, setSelectedDiscountValueType] =
    useState("2");
  const [totalPrice, setTotalPrice] = useState(0);
  const [receiptDiscount, setReceiptDiscount] = useState(0);
  const [subFinal, setSubFinal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [isVatChecked, setIsVatChecked] = useState(false);
  const [vatAmount, setVatAmount] = useState(0);

  // เก็บตัวแปรสำหรับเช็ค
  const [chequeNo, setChequeNo] = useState("");
  const [chequeName, setChequeName] = useState("");
  const [chequeBranch, setChequeBranch] = useState("");
  const [chequeDate, setChequeDate] = useState(moment());

  // เก็บตัวแปรสำหรับธนาคาร
  const [bankMasterId, setBankMasterId] = useState("2");
  const [bankId, setBankId] = useState("");
  const [bankInputMode, setBankInputMode] = useState("select");
  const [payToAccNo, setPayToAccNo] = useState("");
  const [payToAccName, setPayToAccName] = useState("");

  const [base64Image, setBase64Image] = useState("");

  const [showConfirmModal, setShowConfirmModal] = useState(false);

  // การแสดงสถานะใบ
  const [statusName, setStatusName] = useState("");
  const [statusColour, setStatusColour] = useState("");

  // สำหรับส่งไปหน้า FormAction
  const [docStatus, setDocStatus] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [soNo, setSoNo] = useState("");

  // สำหรับเก็บประเภทการชำระเงิน
  const [paymentType, setPaymentType] = useState({});
  const [paymentAmount, setPaymentAmount] = useState({});
  const [payDatetime, setPayDatetime] = useState(moment());

  const [multipleSlipImages, setMultipleSlipImages] = useState([]);
  const [isUploadingSlips, setIsUploadingSlips] = useState(false);

  const [openUploadAttach, setOpenUploadAttach] = useState(false);
  const [showViewAttachModal, setShowViewAttachModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedRecFiles, setSelectedRecFiles] = useState([]);

  // เปิด Modal สำหรับดูรายละเอียดใบขาย
  const [showViewSoModal, setShowViewSoModal] = useState(false);
  const handleViewSoClose = () => {
    setShowViewSoModal(false);
    //setSelectedSoData(null);

    // ลบ class 'modal-open' จาก body
    document.body.classList.remove("modal-open");

    // ลบ element ที่อาจถูกซ้อน เช่น backdrop ของ Modal
    const backdrops = document.getElementsByClassName("modal-backdrop");
    while (backdrops.length > 0) {
      backdrops[0].parentNode.removeChild(backdrops[0]);
    }
  };

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      const docTypeList = await getDocType(2);
      if (docTypeList && docTypeList.length > 0) {
        setTbDocType(docTypeList);
      }

      const transTypeList = await getTransType();
      if (transTypeList && transTypeList.length > 0) {
        setTbTransType(transTypeList);
      }

      const arDataList = await getDataWithComp(
        "Tb_Set_AR",
        "ORDER BY AR_Code ASC"
      );
      if (arDataList && arDataList.length > 0) {
        setArDataList(arDataList);
      }

      const itemDataList = await getViewItem();
      if (itemDataList && itemDataList.length > 0) {
        setItemDataList(itemDataList);
      }

      const whDataList = await getDataWithComp(
        "Tb_Set_Wh",
        "AND Flag_Vansale = 'N' AND WH_Status = 'Y' ORDER BY Flag_Vansale, WH_Name ASC"
      );
      if (whDataList && whDataList.length > 0) {
        setWhDataList(whDataList);
      }

      // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
      if (mode === "U") {
        await getModelByNo(arDataList);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const getModelByNo = async (arDataList) => {
    try {
      // ดึงข้อมูลเอกสารจาก AR_H
      const findMaster = await getDataWithComp("QT_H", ``);
      const fromDatabase = findMaster.find((ar) => ar.Doc_No === maxDocNo);

      if (!fromDatabase) {
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ค้นหาข้อมูลผู้ขายด้วย AR_ID
      const fromViewAr = arDataList.find(
        (ar) => ar.AR_Id === fromDatabase.AR_ID
      );

      if (!fromViewAr) {
        throw new Error("ไม่พบข้อมูลลูกค้า");
      }

      // SET สถานะใช้กับ FormAction
      setDocStatus(fromDatabase.Doc_Status);

      // ค้นหาว่าใบเสนอราคานี้ ทำใบขายแล้วหรือยัง ?
      const findSo = await getDataWithComp(
        "SO_H",
        `AND Doc_Status <> 13 AND Ref_DocID = ${fromDatabase.Doc_Id} AND Ref_Doc LIKE '%QT%'`
      );

      // ดึงไฟล์แนบจากฐานข้อมูล
      if (fromDatabase.Doc_Id) {
        const attachedFiles = await getDataWithComp(
          "Upload_File_List",
          `AND DocCode_ID = 1 AND Doc_ID = ${fromDatabase.Doc_Id}`
        );

        if (Array.isArray(attachedFiles) && attachedFiles.length > 0) {
          setSelectedFiles(attachedFiles);
        } else {
          setSelectedFiles([]);
        }
      } else {
        setSelectedFiles([]);
      }

      if (findSo && findSo.length > 0) {
        setDisabled(true);
        setSoNo(findSo[0].Doc_No);
      } else {
        setDisabled(false);
        setSoNo("");
      }

      setPaymentType({
        cash: false,
        transfer: false,
        cheque: false,
        credit: false,
        unpaid: false,
      });
      setPaymentAmount({
        cash: "0.00",
        transfer: "0.00",
        cheque: "0.00",
        credit: "0.00",
        unpaid: "0.00",
      });

      // ค้นหาข้อมูล VIEW
      const findViewMaster = await getDataWithComp("API_0601_QT_H", "");
      const fromView = findViewMaster.find((data) => data.Doc_No === maxDocNo);
      setStatusName(fromView.DocStatus_Name);
      setStatusColour(fromView.DocStatus_Colour);

      // ฟังก์ชันเพื่อสร้างโมเดลใหม่สำหรับแต่ละแถวและคำนวณ itemTotal
      const createNewRow = (index, itemSelected) => {
        const itemQty = parseCurrency(itemSelected.Item_Qty) || 0;
        const itemPriceUnit = parseCurrency(itemSelected.Item_Price_Unit) || 0;
        const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;
        const itemDisType = String(itemSelected.Item_DisType);
        let itemTotal = itemQty * itemPriceUnit;

        if (itemDisType === "2") {
          itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
        } else {
          itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
        }

        return {
          ...qtDetailModel(index + 1),
          dtId: itemSelected.DT_Id,
          docId: itemSelected.Doc_ID,
          line: itemSelected.Line,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: formatCurrency(itemQty),
          itemUnit: itemSelected.Item_Unit,
          itemPriceUnit: formatCurrency(itemPriceUnit),
          itemDiscount: formatCurrency(itemDiscount),
          itemDisType,
          itemTotal,
          itemStatus: itemSelected.Item_Status,
          whName: itemSelected.WH_Name,
          ltId: itemSelected.LT_ID,
          dsSeq: itemSelected.DS_SEQ,
        };
      };

      // ค้นหาข้อมูลของ Detail ด้วย Doc_ID
      const fromDetail = await getByDocId(
        "QT_D",
        fromDatabase.Doc_Id,
        `ORDER BY Line ASC`
      );
      if (fromDetail.length > 0) {
        const newFormDetails = fromDetail.map((item, index) =>
          createNewRow(formDetailList.length + index, item)
        );
        setFormDetailList(newFormDetails);

        setFormMasterList({
          docId: fromDatabase.Doc_Id,
          docNo: fromDatabase.Doc_No,
          docDate: convertDate(fromDatabase.Doc_Date, false) || null,
          docDueDate: convertDate(fromDatabase.Doc_DueDate, false) || null,
          docStatus: fromDatabase.Doc_Status,
          docCode: fromDatabase.Doc_Code,
          docType: fromDatabase.Doc_Type,
          docFor: fromDatabase.Doc_For,
          docIsPO: fromDatabase.Doc_Is_PO,
          refDocID: fromDatabase.Ref_DocID,
          refDoc: fromDatabase.Ref_Doc,
          refDocDate: fromDatabase.Ref_DocDate,
          compId: fromDatabase.Comp_Id,
          refProjectID: fromDatabase.Ref_ProjectID,
          refProjectNo: fromDatabase.Ref_ProjectNo,
          transportType: fromDatabase.Transport_Type,
          docRemark1: fromDatabase.Doc_Remark1,
          docRemark2: fromDatabase.Doc_Remark2,
          arID: fromDatabase.AR_ID,
          arCode: fromDatabase.AR_Code,
          actionHold: fromDatabase.Action_Hold,
          discountValue: fromDatabase.Discount_Value,
          discountValueType: fromDatabase.Discount_Value_Type,
          discountCash: fromDatabase.Discount_Cash,
          discountCashType: fromDatabase.Discount_Cash_Type,
          discountTransport: fromDatabase.Discount_Transport,
          discountTransportType: fromDatabase.Discount_Transport_Type,
          isVat: fromDatabase.IsVat,
          docSEQ: fromDatabase.Doc_SEQ,
          creditTerm: fromDatabase.CreditTerm,
          creditTerm1Day: fromDatabase.CreditTerm1Day,
          creditTerm1Remark: fromDatabase.CreditTerm1Remark,
          creditTerm2Remark: fromDatabase.CreditTerm2Remark,
          accCode: fromDatabase.ACC_Code,
          empName: fromDatabase.EmpName,
          createdDate: setCreateDateTime(fromDatabase.Created_Date || null),
          createdByName: fromDatabase.Created_By_Name,
          createdById: fromDatabase.Created_By_Id,
          updateDate: setCreateDateTime(fromDatabase.Update_Date || null),
          updateByName: fromDatabase.Update_By_Name,
          updateById: fromDatabase.Update_By_Id,
          approvedDate: setCreateDateTime(fromDatabase.Approved_Date || null),
          approvedByName: fromDatabase.Approved_By_Name,
          approvedById: fromDatabase.Approved_By_Id,
          cancelDate: setCreateDateTime(fromDatabase.Cancel_Date || null),
          cancelByName: fromDatabase.Cancel_By_Name,
          cancelById: fromDatabase.Cancel_By_Id,
          approvedMemo: fromDatabase.Approved_Memo,
          printedStatus: fromDatabase.Printed_Status,
          printedDate: setCreateDateTime(fromDatabase.Printed_Date || null),
          printedBy: fromDatabase.Printed_By,

          // ข้อมูลลูกค้า
          arName: fromViewAr.AR_Name,
          arAdd1: fromViewAr.AR_Add1,
          arAdd2: fromViewAr.AR_Add2,
          arAdd3: fromViewAr.AR_Add3,
          arProvince: fromViewAr.AR_Province,
          arZipcode: fromViewAr.AR_Zipcode,
          arTaxNo: fromViewAr.AR_TaxNo,
        });

        setIsVatChecked(fromDatabase.IsVat === 1);

        const discountValueType = parseCurrency(
          fromDatabase.Discount_Value_Type
        );
        if (!isNaN(discountValueType)) {
          setSelectedDiscountValueType(discountValueType.toString());
        }
      } else {
        getAlert(
          "FAILED",
          `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${fromDatabase.Doc_No} กรุณาตรวจสอบและลองอีกครั้ง`
        );
      }
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  const handleCheckboxChange = (event) => {
    const { name } = event.target;
    setSelectedDiscountValueType(
      selectedDiscountValueType === name ? null : name
    );
  };

  const handleSubmit = async () => {
    try {
      // ทดสอบหน่วงเวลาก่อนบันทึก (ทดสอบป้องกันการซ้ำของ Doc_No)
      await randomDelay();

      const newMaxDoc = await getSpRunNumber("QT");
      if (!newMaxDoc) {
        getAlert("FAILED", "ไม่สามารถสร้างเลขที่เอกสารได้");
        return;
      }

      // ตรวจสอบค่า formMasterList.arID และ formMasterList.arCode
      if (!formMasterList.arID && !formMasterList.arCode) {
        getAlert("FAILED", "กรุณาเลือกผู้ขาย");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ arCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          getAlert("FAILED", `กรุณากรอกจำนวนของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
        }
        if (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0) {
          getAlert("FAILED", `กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากราคาต่อหน่วยเป็น 0 หรือไม่มีค่า
        }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: newMaxDoc,
        doc_date: convertDate(formMasterList.docDate, true),
        doc_due_date: convertDate(formMasterList.docDueDate, true),
        doc_status: parseCurrency("2", 10),
        doc_code: parseCurrency("1", 10),
        doc_type: parseCurrency(formMasterList.docType, 10),
        doc_for: formMasterList.docFor,
        doc_is_po: parseCurrency("0", 10),
        ref_doc_id: formMasterList.refDocID,
        ref_doc: formMasterList.refDoc,
        ref_doc_date: formMasterList.refDocDate,
        comp_id: window.localStorage.getItem("company"),
        ref_project_id: formMasterList.refProjectID,
        ref_project_no: formMasterList.refProjectNo,
        transport_type: formMasterList.transportType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        ar_id: parseCurrency(formMasterList.arID, 10),
        ar_code: formMasterList.arCode,
        action_hold: parseCurrency("0", 10),
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseCurrency(selectedDiscountValueType, 10),
        discount_cash: parseCurrency("0.00"),
        discount_cash_type: formMasterList.discountCashType,
        discount_transport: parseCurrency("0.00"),
        discount_transport_type: formMasterList.discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1", 10) : parseCurrency("2", 10),
        doc_seq: formatDateTime(new Date()),
        credit_term: parseCurrency(formMasterList.creditTerm, 10),
        credit_term_1_day: parseCurrency("0", 10),
        credit_term_1_remark: formMasterList.creditTerm1Remark,
        credit_term_2_remark: formMasterList.creditTerm2Remark,
        acc_code: "0000",
        emp_name: formMasterList.empName,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: window.localStorage.getItem("name"),
        created_by_id: window.localStorage.getItem("emp_id"),
        update_date: null,
        update_by_name: null,
        update_by_id: null,
        approved_date: null,
        approved_by_name: null,
        approved_by_id: null,
        cancel_date: null,
        cancel_by_name: null,
        cancel_by_id: null,
        approved_memo: null,
        printed_status: "N",
        printed_date: null,
        printed_by: null,
      };

      // For Log PR_H
      // console.log("api/create-qt-h formMasterData =>", formMasterData);

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-qt-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        const getDocIdResponse = await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/get-by-doc-no`,
          {
            table: "QT_H",
            doc_no: formMasterData.doc_no,
            comp_id: window.localStorage.getItem("company"),
          },
          {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          }
        );

        // ส่งข้อมูลรายละเอียดหากพบ Doc_Id
        if (getDocIdResponse && getDocIdResponse.data.length > 0) {
          const docId = parseCurrency(getDocIdResponse.data[0].Doc_Id, 10);

          const detailPromises = formDetailList.map(async (item, index) => {
            const formDetailData = {
              doc_id: parseCurrency(docId, 10),
              line: index + 1,
              item_id: item.itemId,
              item_code: item.itemCode,
              item_name: item.itemName,
              item_qty: parseCurrency(item.itemQty),
              item_unit: item.itemUnit,
              item_price_unit: parseCurrency(item.itemPriceUnit),
              item_discount: parseCurrency(item.itemDiscount),
              item_distype:
                item.itemDisType === "1"
                  ? parseCurrency("1", 10)
                  : parseCurrency("2", 10),
              item_total: parseCurrency(item.itemTotal),
              item_status: parseCurrency("1", 10),
              lt_id: parseCurrency("1", 10),
              ds_seq: formatDateTime(new Date()),
            };

            // For Log PR_D
            // console.log("formDetailData : ", formDetailData);

            return Axios.post(
              `${process.env.REACT_APP_API_URL}/api/create-qt-d`,
              formDetailData,
              {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
              }
            );
          });

          await Promise.all(detailPromises);

          // อัพโหลดไฟล์แนบ (ถ้ามี)
          if (selectedFiles.length > 0) {
            try {
              const response = await Axios.post(
                `${process.env.REACT_APP_API_URL}/api/upload-file`,
                {
                  comp_id: window.localStorage.getItem("company"),
                  doc_id: docId,
                  DocCode_ID: 1, // QT document type
                  upload_by: window.localStorage.getItem("name"),
                  file_status: "Y",
                  files: selectedFiles,
                  doc_no_ref: null,
                }
              );
              if (response.data.status !== "SUCCESS") {
                getAlert("FAILED", "อัปโหลดไฟล์ล้มเหลว กรุณาลองใหม่อีกครั้ง");
              }
            } catch (error) {
              getAlert("FAILED", "เกิดข้อผิดพลาดขณะอัปโหลดไฟล์");
            }
          }
        }

        callInitialize();
        // setMode("U");
        // initialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleSubmitSo = async (
    docStatusPaid,
    docStatusPaidType,
    totalPaidAmount
  ) => {
    try {
      let newMaxDoc = "UNKNOWN"; // กำหนดค่าเริ่มต้น
      let newMaxRec = null; // กำหนดค่าเริ่มต้น
      let newDateRec = null; // กำหนดค่าเริ่มต้น

      if (paymentType.credit) {
        // กรณีลูกค้าขายเชื่อ
        if (isVatChecked) {
          // VAT
          newMaxDoc = await getSpRunNumber("INV");
        } else {
          // ไม่ VAT
          newMaxDoc = await getSpRunNumber("DSR");
        }
      } else {
        // กรณีลูกค้าขายสด
        if (isVatChecked) {
          // VAT
          newMaxDoc = await getSpRunNumber("INV");

          // ทำการสร้างใบเสร็จรับเงิน และ รันเลข REC ที่ Tb_Set_Rec_No ล่าสุด
          const findMaxRecNo = await getData(
            "Tb_Set_Rec_No",
            `1 = 1 ORDER BY RecNo DESC`
          );
          newMaxRec = getMaxRecNoForTest(findMaxRecNo);
          newDateRec = getCreateDateTime();
          await createSetRecNo(newMaxRec);
        } else {
          // ไม่ VAT
          newMaxDoc = await getSpRunNumber("CS");
        }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        comp_id: window.localStorage.getItem("company"),
        doc_no: newMaxDoc,
        doc_date: convertDate(moment(), false),
        doc_status: parseCurrency("2"),
        doc_status_transport: parseCurrency("1"),
        doc_status_receive: parseCurrency("1"),
        doc_status_paid: parseCurrency(docStatusPaid),
        doc_status_paid_type: parseCurrency(docStatusPaidType),
        doc_code: parseCurrency("7"),
        doc_type: parseCurrency("10"),
        doc_for: formMasterList.docFor,
        doc_is_picking_list: 0,
        doc_is_inv: "N",
        doc_inv_no: newMaxRec,
        doc_is_inv_from: parseCurrency("0"),
        ref_doc_id: formMasterList.docId,
        ref_doc: formMasterList.docNo,
        ref_doc_date: convertDate(moment(), false),
        ref_project_id: formMasterList.refProjectID,
        ref_project_no: formMasterList.refProjectNo,
        transport_type: formMasterList.transportType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        ar_id: parseCurrency(formMasterList.arID, 10),
        ar_code: formMasterList.arCode,
        doc_due_date: convertDate(formMasterList.docDueDate, false),
        action_hold: parseCurrency("0", 10),
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseCurrency(selectedDiscountValueType, 10),
        discount_cash: parseCurrency("0.00"),
        discount_cash_type: formMasterList.discountCashType,
        discount_transport: parseCurrency("0.00"),
        discount_transport_type: formMasterList.discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1", 10) : parseCurrency("2", 10),
        doc_seq: formatDateTime(new Date()),
        credit_term: parseCurrency(formMasterList.creditTerm, 10),
        credit_term_1_day: formMasterList.creditTerm1Day,
        credit_term_1_remark: formMasterList.creditTerm1Remark,
        credit_term_2_remark: formMasterList.creditTerm2Remark,
        acc_code: "0000",
        emp_name: formMasterList.empName,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: formMasterList.createdByName,
        created_by_id: formMasterList.createdById,
        update_date: null,
        update_by_name: null,
        update_by_id: null,
        cancel_date: null,
        cancel_by_name: null,
        cancel_by_id: null,
        printed_status: "N",
        printed_date: null,
        printed_by: null,
        pay_total: parseCurrency(
          paymentType.credit || paymentType.unpaid ? "0" : totalPaidAmount
        ),
        ref_bill_no: null,
        doc_so_receive_date: newDateRec
          ? formatThaiDateUiToDate(newDateRec)
          : null,
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-so-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        const getDocIdResponse = await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/get-by-doc-no`,
          {
            table: "SO_H",
            doc_no: formMasterData.doc_no,
            comp_id: window.localStorage.getItem("company"),
          },
          {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          }
        );

        // ส่งข้อมูลรายละเอียดหากพบ Doc_Id
        if (getDocIdResponse && getDocIdResponse.data.length > 0) {
          const docId = parseCurrency(getDocIdResponse.data[0].Doc_Id, 10);

          // สร้าง Detail ของใบขาย
          const detailPromises = formDetailList.map(async (item, index) => {
            const formDetailData = {
              doc_id: parseCurrency(docId, 10),
              line: index + 1,
              item_id: item.itemId,
              item_code: item.itemCode,
              item_name: item.itemName,
              item_qty: parseCurrency(item.itemQty),
              item_unit: item.itemUnit,
              item_price_unit: parseCurrency(item.itemPriceUnit),
              item_discount: parseCurrency(item.itemDiscount),
              item_distype:
                item.itemDisType === "1"
                  ? parseCurrency("1", 10)
                  : parseCurrency("2", 10),
              item_total: parseCurrency(item.itemTotal),
              item_status: parseCurrency("1", 10),
              ds_seq: item.dsSeq,
              wh_id: item.whId,
              item_rec_qty: parseCurrency("0"),
            };

            return Axios.post(
              `${process.env.REACT_APP_API_URL}/api/create-so-d`,
              formDetailData,
              {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
              }
            );
          });

          await Promise.all(detailPromises);

          // จัดการ Payment History
          const paymentTypeMap = {
            cash: 1,
            transfer: 2,
            cheque: 3,
            credit: 4,
            unpaid: 5,
          };
          const paymentHistoryPromises = [];

          for (const method of Object.keys(paymentType)) {
            if (
              paymentType[method] &&
              parseCurrency(paymentAmount[method]) > 0 &&
              (paymentTypeMap[method] === 1 ||
                paymentTypeMap[method] === 2 ||
                paymentTypeMap[method] === 3)
            ) {
              let bank_master_id_val = null;
              let bank_id_val = null;
              let pay_to_acc_no_val = null;
              let pay_to_acc_name_val = null;

              if (method === "transfer" || method === "cheque") {
                if (bankInputMode === "manual" || method === "cheque") {
                  bank_master_id_val = bankMasterId || null;
                  pay_to_acc_no_val = payToAccNo || null;
                  pay_to_acc_name_val = payToAccName || null;
                } else if (bankInputMode === "select") {
                  bank_id_val = bankId || null;
                }
              }

              const formPaymentHistoryData = {
                doc_code_id: 7,
                doc_id: getDocIdResponse.data[0].Doc_Id,
                pay_type: paymentTypeMap[method],
                pay_amount:
                  docStatusPaidType === 6
                    ? parseCurrency(paymentAmount[method])
                    : parseCurrency(totalPaidAmount),
                pay_remark: null,
                pay_datetime: moment(paymentTypeMap[method] === 3 ? chequeDate : payDatetime)
                  .utcOffset(7, true)
                  .format("YYYY-MM-DD HH:mm:ss.SSS"),
                pay_by: localStorage.getItem("name"),
                pay_to_acc_no: pay_to_acc_no_val,
                pay_to_branch: null,
                pay_to_acc_name: pay_to_acc_name_val,
                pay_cheque_no: paymentTypeMap[method] === 3 ? chequeNo : null,
                pay_cheque_name:
                  paymentTypeMap[method] === 3 ? chequeName : null,
                pay_cheque_branch:
                  paymentTypeMap[method] === 3
                    ? chequeBranch || "ธนาคารกสิกรไทย"
                    : null,
                pay_cheque_date:
                  paymentTypeMap[method] === 3
                    ? moment(chequeDate)
                      .utcOffset(7, true)
                      .format("YYYY-MM-DD HH:mm:ss.SSS")
                    : null,
                pay_cheque_type: null,
                comp_id: localStorage.getItem("company"),
                bank_master_id: bank_master_id_val,
                bank_id: bank_id_val,
                doc_ref: null,
              };

              // ส่งข้อมูลไปยัง API
              const paymentHistoryPromise = Axios.post(
                `${process.env.REACT_APP_API_URL}/api/create-pay-history`,
                formPaymentHistoryData,
                {
                  headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
                }
              );
              paymentHistoryPromises.push(paymentHistoryPromise);
            }
          }
          await Promise.all(paymentHistoryPromises);
          await new Promise((resolve) => setTimeout(resolve, 1000));
          // *** จัดการอัพโหลดสลิป - ย้ายมาไว้ที่นี่หลังจากได้ docId แล้ว ***
          if (paymentType.transfer) {
            try {
              setIsUploadingSlips(true);

              if (multipleSlipImages && multipleSlipImages.length > 0) {
                const slipFiles = multipleSlipImages.map(
                  (image) => image.base64
                );
                await uploadMultipleSlips(slipFiles, docId, 7);
              } else if (base64Image) {
                try {
                  await uploadSlip(base64Image, docId, 6);
                  console.log(`✅ Uploaded single slip file successfully`);
                } catch (err) {
                  console.error("Error uploading single slip:", err);
                }
              }
            } catch (uploadError) {
              console.error("Error uploading slips:", uploadError);
            } finally {
              setIsUploadingSlips(false);
            }
          }

          // ค้นหาข้อมูลล่าสุด และทำการอัพเดตค่าใน PAYMENT_ONHAND & PAYMENT_STC
          const getOldData = await getDataWithComp(
            "API_0701_SO_H",
            `AND Doc_ID = ${docId}`
          );
          if (getOldData && getOldData.length > 0) {
            const data = getOldData[0];
            // ปรับยอดเงินออก (เริ่มต้น)
            await manageWhArPaymentData(
              data.AR_ID, // AR_ID ของลูกค้านั้นๆ
              data.AR_Code, // AR_Code ของสิ่งนั้นๆ
              data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
              0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
              "AO", // ประเภท เช่น AI/AO
              parseCurrency(data.NetTotal), // ค่าจำนวนเงิน
              data.Doc_ID, // ไอดีเอกสาร
              data.Doc_No, // เลขเอกสาร
              data.Ref_Doc === null ? data.Doc_No : data.Ref_Doc, // เลขเอกสารอ้างอิง
              null, // หมายเหตุ
              paymentType.credit ? parseCurrency("4") : parseCurrency("5") // ช่องทางการชำระ
            );

            if (
              paymentType.cash ||
              paymentType.transfer ||
              paymentType.cheque
            ) {
              if (data.Doc_Status_Paid_Type === 6) {
                const getPayHistory = await getData(
                  "Pay_History",
                  `DocCode_Id = 7 AND Doc_Id = ${docId}` // ใช้ docId แทน formMasterList.docId
                );
                if (getPayHistory && getPayHistory.length > 0) {
                  for (const pay of getPayHistory) {
                    await manageWhArPaymentData(
                      data.AR_ID, // AR_ID ของลูกค้านั้นๆ
                      data.AR_Code, // AR_Code ของสิ่งนั้นๆ
                      data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
                      0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
                      "AI", // ประเภท เช่น AI/AO
                      parseCurrency(pay.Pay_Amount), // ค่าจำนวนเงิน
                      data.Doc_ID, // ไอดีเอกสาร
                      data.Doc_No, // เลขเอกสาร
                      data.Ref_Doc === null ? data.Doc_No : data.Ref_Doc, // เลขเอกสารอ้างอิง
                      await setRemarkByPaymentType(parseCurrency(pay.Pay_Type)), // หมายเหตุ
                      parseCurrency(pay.Pay_Type) // ช่องทางการชำระ
                    );
                  }
                }
              } else {
                // ปรับยอดเงินออก
                await manageWhArPaymentData(
                  data.AR_ID, // AR_ID ของลูกค้านั้นๆ
                  data.AR_Code, // AR_Code ของสิ่งนั้นๆ
                  data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
                  0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
                  "AI", // ประเภท เช่น AI/AO
                  parseCurrency(data.Pay_Total), // ค่าจำนวนเงิน
                  data.Doc_ID, // ไอดีเอกสาร
                  data.Doc_No, // เลขเอกสาร
                  data.Ref_Doc === null ? data.Doc_No : data.Ref_Doc, // เลขเอกสารอ้างอิง
                  await setRemarkByPaymentType(
                    parseCurrency(data.Doc_Status_Paid_Type)
                  ), // หมายเหตุ
                  parseCurrency(data.Doc_Status_Paid_Type) // ช่องทางการชำระ
                );
              }
            }
          }
        }
      }
      callInitialize();
      getAlert("OK", "บันทึกรายการใบขายสำเร็จ");
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdate = async () => {
    try {
      // ตรวจสอบค่า formMasterList.arID และ formMasterList.arCode
      if (!formMasterList.arID && !formMasterList.arCode) {
        getAlert("FAILED", "กรุณาเลือกลูกค้า");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า arID หรือ arCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          getAlert("FAILED", `กรุณากรอกจำนวนของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
        }
        if (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0) {
          getAlert("FAILED", `กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากราคาต่อหน่วยเป็น 0 หรือไม่มีค่า
        }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_date: formMasterList.docDate,
        doc_due_date: formMasterList.docDueDate,
        doc_status: parseCurrency(formMasterList.docStatus, 10),
        doc_code: parseCurrency(formMasterList.docCode, 10),
        doc_type: formMasterList.docType,
        doc_for: formMasterList.docFor,
        doc_is_po: parseCurrency(formMasterList.docIsPO, 10),
        ref_doc_id: formMasterList.refDocID,
        ref_doc: formMasterList.refDoc,
        ref_doc_date: formMasterList.refDocDate,
        comp_id: formMasterList.compId,
        ref_project_id: formMasterList.refProjectID,
        ref_project_no: formMasterList.refProjectNo,
        transport_type: formMasterList.transportType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        ar_id: parseCurrency(formMasterList.arID, 10),
        ar_code: formMasterList.arCode,
        action_hold: parseCurrency(formMasterList.actionHold, 10),
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseCurrency(
          formMasterList.discountValueType,
          10
        ),
        discount_cash: parseCurrency(formMasterList.discountCash),
        discount_cash_type: formMasterList.discountCashType,
        discount_transport: parseCurrency(formMasterList.discountTransport),
        discount_transport_type: formMasterList.discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1", 10) : parseCurrency("2", 10),
        doc_seq: formMasterList.docSEQ,
        credit_term: parseCurrency(formMasterList.creditTerm, 10),
        credit_term_1_day: parseCurrency(formMasterList.creditTerm1Day, 10),
        credit_term_1_remark: formMasterList.creditTerm1Remark,
        credit_term_2_remark: formMasterList.creditTerm2Remark,
        acc_code: formMasterList.accCode,
        emp_name: formMasterList.empName,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: formMasterList.createdByName,
        created_by_id: formMasterList.createdById,
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        approved_date: formatThaiDateUiToDate(formMasterList.approvedDate),
        approved_by_name: formMasterList.approvedByName,
        approved_by_id: formMasterList.approvedById,
        cancel_date: formatThaiDateUiToDate(formMasterList.cancelDate),
        cancel_by_name: formMasterList.cancelByName,
        cancel_by_id: formMasterList.cancelById,
        approved_memo: formMasterList.approvedMemo,
        printed_status: formMasterList.printedStatus,
        printed_date: formatThaiDateUiToDate(formMasterList.printedDate),
        printed_by: formMasterList.printedBy,
      };

      // For Log PR_H
      // console.log("formMasterData : ", formMasterData);

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-qt-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        // ลบข้อมูลเดิมก่อนจะเริ่มการบันทึกใหม่
        await deleteData("QT_D", `WHERE Doc_ID = ${formMasterList.docId}`);

        const docId = parseCurrency(formMasterList.docId, 10);

        const detailPromises = formDetailList.map(async (item, index) => {
          const formDetailData = {
            doc_id: parseCurrency(docId, 10),
            line: index + 1,
            item_id: item.itemId,
            item_code: item.itemCode,
            item_name: item.itemName,
            item_qty: parseCurrency(item.itemQty),
            item_unit: item.itemUnit,
            item_price_unit: parseCurrency(item.itemPriceUnit),
            item_discount: parseCurrency(item.itemDiscount),
            item_distype:
              item.itemDisType === "1"
                ? parseCurrency("1", 10)
                : parseCurrency("2", 10),
            item_total: parseCurrency(item.itemTotal),
            item_status: parseCurrency("1", 10),
            lt_id: parseCurrency("1", 10),
            ds_seq: formatDateTime(new Date()),
          };

          // For Log PR_D
          // console.debug("formDetailData : ", formDetailData);

          return Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-qt-d`,
            formDetailData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );
        });

        await Promise.all(detailPromises);

        // อัพโหลดไฟล์ใหม่ (ถ้ามี)
        await Promise.all(detailPromises);

        // อัพโหลดไฟล์ใหม่ (ถ้ามี) - เพิ่มส่วนนี้
        if (selectedFiles.length > 0) {
          try {
            const filteredFiles = selectedFiles.filter((file) => {
              if (typeof file === "string") {
                return false;
              }
              return file && typeof file === "object" && file.isPending;
            });

            if (filteredFiles.length > 0) {
              const response = await Axios.post(
                `${process.env.REACT_APP_API_URL}/api/upload-file`,
                {
                  comp_id: window.localStorage.getItem("company"),
                  doc_id: formMasterList.docId,
                  DocCode_ID: 1,
                  upload_by: window.localStorage.getItem("name"),
                  file_status: "Y",
                  files: filteredFiles,
                  doc_no_ref: null,
                }
              );

              if (response.data.status !== "SUCCESS") {
                getAlert("FAILED", "อัปโหลดไฟล์ล้มเหลว กรุณาลองใหม่อีกครั้ง");
              }
            }
          } catch (error) {
            getAlert("FAILED", "เกิดข้อผิดพลาดขณะอัปโหลดไฟล์");
          }
        }

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancel = async () => {
    try {
      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_status: parseCurrency("13", 10),
        cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
        cancel_by_name: window.localStorage.getItem("name"),
        cancel_by_id: window.localStorage.getItem("emp_id"),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-qt-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      callInitialize();
      getAlert(response.data.status, response.data.message);
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleRemoveImage = (index) => {
    const newFiles = selectedFiles.filter((_, i) => i !== index);
    setSelectedFiles(newFiles);
  };

  function handleInputFileChange(e) {
    const files = e.target.files;
    const file = files ? files[0] : null;
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const fileData = {
          id: Date.now(),
          name: file.name,
          type: file.type,
          size: file.size,
          dataUrl: e.target?.result,
          isPending: true,
          displayName: file.name,
        };
        setSelectedFiles((prev) => [...prev, fileData]);
      };
      reader.readAsDataURL(file);
    }
  }

  const handleBeforeUploadAttach = async () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*, .pdf, .doc, .docx, .xls, .xlsx";
    input.multiple = false;
    input.onchange = (e) => handleInputFileChange(e);
    input.click();
    setOpenUploadAttach(true);
  };

  const handleChangeMaster = (e) => {
    const { name, value } = e.target;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDateMaster = (value, name) => {
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value ? value.format("YYYY-MM-DD") : null,
    }));
  };

  const handleChangeDetail = async (index, field, value) => {
    // ตรวจสอบว่าค่าที่กรอกเข้ามาเป็นตัวเลขหรือตัวเลขที่มีจุดทศนิยม
    if (!/^\d*\.?\d*$/.test(value)) {
      //getAlert("FAILED", "กรุณากรอกเฉพาะตัวเลขเท่านั้น");
      return;
    }

    const updatedList = [...formDetailList];
    updatedList[index][field] = value;

    const itemQty = parseCurrency(updatedList[index].itemQty) || 0;
    const itemPriceUnit = parseCurrency(updatedList[index].itemPriceUnit) || 0;
    const itemDiscount = parseCurrency(updatedList[index].itemDiscount) || 0;
    const itemDisType = String(updatedList[index].itemDisType);

    let itemTotal = itemQty * itemPriceUnit;
    itemTotal -=
      itemDisType === "2" ? (itemDiscount / 100) * itemTotal : itemDiscount;
    updatedList[index].itemTotal = itemTotal;

    setFormDetailList(updatedList);
  };

  const handleFocus = (index, field) => {
    const updatedList = [...formDetailList];
    updatedList[index][field] =
      parseCurrency(updatedList[index][field].replace(/,/g, "")) || 0;
    setFormDetailList(updatedList);
  };

  const handleBlur = (index, field, value) => {
    const numericValue = parseCurrency(value.replace(/,/g, "")) || 0;
    const formattedValue = formatCurrency(numericValue);

    const updatedList = [...formDetailList];
    updatedList[index][field] = formattedValue;
    setFormDetailList(updatedList);
  };

  const handleMultipleSlipUpload = (event) => {
    const files = Array.from(event.target.files);

    if (files.length > 10) {
      getAlert("FAILED", "สามารถอัพโหลดได้ไม่เกิน 10 ไฟล์");
      event.target.value = "";
      return;
    }

    if (multipleSlipImages.length + files.length > 10) {
      getAlert(
        "FAILED",
        `สามารถอัพโหลดได้ไม่เกิน 10 ไฟล์ (ปัจจุบันมี ${multipleSlipImages.length} ไฟล์)`
      );
      event.target.value = "";
      return;
    }

    const newImages = [];
    let processedFiles = 0;

    files.forEach((file, index) => {
      if (file.size > 5 * 1024 * 1024) {
        getAlert("FAILED", `ไฟล์ ${file.name} มีขนาดใหญ่เกิน 5MB`);
        return;
      }

      if (
        file &&
        (file.type.startsWith("image/") || file.type === "application/pdf")
      ) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const base64 = e.target.result;
          newImages.push({
            id: Date.now() + index,
            base64: base64,
            name: file.name,
            type: file.type,
          });

          processedFiles++;

          if (processedFiles === files.length) {
            setMultipleSlipImages((prev) => [...prev, ...newImages]);
            if (base64Image) {
              setBase64Image("");
            }
          }
        };

        reader.onerror = () => {
          getAlert("FAILED", `ไม่สามารถอ่านไฟล์ ${file.name} ได้`);
        };

        reader.readAsDataURL(file);
      } else {
        getAlert("FAILED", `ไฟล์ ${file.name} ไม่ใช่รูปภาพหรือ PDF ที่รองรับ`);
      }
    });

    event.target.value = "";
  };

  const handleRemoveSlipImage = (imageId) => {
    setMultipleSlipImages((prev) => prev.filter((img) => img.id !== imageId));
  };

  const handleClearAllSlips = () => {
    setMultipleSlipImages([]);
    setBase64Image("");
    const fileInput = document.getElementById("multipleFileInput");
    if (fileInput) {
      fileInput.value = "";
    }
  };

  // SET AR
  const [showArModal, setShowArModal] = useState(false);
  const handleArShow = () => setShowArModal(true);
  const handleArClose = () => setShowArModal(false);
  const onRowSelectAr = (arSelected) => {
    try {
      setFormMasterList({
        ...formMasterList,
        arID: arSelected.AR_Id,
        arCode: arSelected.AR_Code,
        arName: arSelected.AR_Name,
        arAdd1: arSelected.AR_Add1,
        arAdd2: arSelected.AR_Add2,
        arAdd3: arSelected.AR_Add3,
        arProvince: arSelected.AR_Province,
        arZipcode: arSelected.AR_Zipcode,
        arTaxNo: arSelected.AR_TaxNo,
      });
      handleArClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET ITEM
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = () => setShowItemModal(true);
  const handleItemClose = () => setShowItemModal(false);
  const getCustomerSpecificPrices = async (itemsSelected) => {
    const compId = window.localStorage.getItem("company");
    const arId = formMasterList?.arID;

    if (
      compId !== "1" ||
      !arId ||
      !Array.isArray(itemsSelected) ||
      itemsSelected.length === 0
    ) {
      return {};
    }

    const uniqueItemIds = [
      ...new Set(
        itemsSelected
          .map((item) => {
            const parsed = parseInt(item?.Item_Id, 10);
            return Number.isNaN(parsed) ? null : parsed;
          })
          .filter((id) => id !== null)
      ),
    ];

    if (uniqueItemIds.length === 0) {
      return {};
    }

    const itemCondition =
      uniqueItemIds.length === 1
        ? `AND Item_Id = ${uniqueItemIds[0]}`
        : `AND Item_Id IN (${uniqueItemIds.join(",")})`;

    try {
      const response = await getDataWithComp(
        "Tb_Set_Item_Price",
        `AND Comp_Id = ${compId} AND AR_Id = ${arId} ${itemCondition}`
      );

      if (!Array.isArray(response)) {
        return {};
      }

      return response.reduce((acc, row) => {
        if (row?.Item_Id == null) {
          return acc;
        }

        const numericPrice = Number(row.Item_Price);
        if (Number.isNaN(numericPrice)) {
          return acc;
        }

        acc[String(row.Item_Id)] = numericPrice;
        return acc;
      }, {});
    } catch {
      return {};
    }
  };
  const onRowSelectItem = async (itemsSelected) => {
    try {
      if (!Array.isArray(itemsSelected) || itemsSelected.length === 0) {
        handleItemClose();
        return;
      }

      const priceByItem = await getCustomerSpecificPrices(itemsSelected);

      setFormDetailList([
        ...formDetailList,
        ...itemsSelected.map((itemSelected) => {
          const defaultPrice = parseCurrency(itemSelected.Item_Price) || 0;
          const overridePrice = priceByItem[String(itemSelected.Item_Id)];
          const resolvedPrice =
            typeof overridePrice === "number" && !Number.isNaN(overridePrice)
              ? overridePrice
              : defaultPrice;

          return {
            line: null,
            itemId: itemSelected.Item_Id,
            itemCode: itemSelected.Item_Code,
            itemName: itemSelected.Item_Name,
            itemQty: formatCurrency(0),
            itemUnit: itemSelected.Item_Unit_ST,
            itemPriceUnit: formatCurrency(resolvedPrice),
            itemDiscount: formatCurrency(0),
            itemDisType: "1",
            itemTotal: 0,
            itemStatus: itemSelected.Item_Status,
            whId: null,
            whName: itemSelected.WH_Name,
            zoneId: null,
            ltId: null,
            dsSeq: null,
          };
        }),
      ]);
      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  const handleDuplicateRow = (index) => {
    const newItem = { ...formDetailList[index] };
    const newList = [
      ...formDetailList.slice(0, index + 1),
      newItem,
      ...formDetailList.slice(index + 1),
    ];
    setFormDetailList(newList);
  };
  const handleRemoveRow = async (index) => {
    setFormDetailList([]);
    setTimeout(() => {
      const newList = formDetailList.filter((_, i) => i !== index);
      setFormDetailList(newList);
    }, 50);
  };
  const handleVatChange = () => {
    setIsVatChecked((prev) => !prev);
  };

  // SET PAYMENT
  const [showPayTypeModal, setShowPayTypeModal] = useState(false);
  const handlePayTypeShow = () => setShowPayTypeModal(true);
  const handlePayTypeClose = async () => {
    setShowPayTypeModal(false);
    setPaymentType({});
    setPaymentAmount({});

    setMultipleSlipImages([]);
    setBase64Image("");

    if (mode === "U") {
      await initialize();
    }
  };

  const handleUpdatePayment = async () => {
    try {
      // ตรวจสอบค่าว่าเลือกประเภทการชำระเงินหรือยัง
      if (!paymentType) {
        getAlert("FAILED", "กรุณาเลือกประเภทการชำระเงิน");
        return; // หยุดการทำงานของฟังก์ชันหากไม่ได้เลือกประเภทการชำระเงิน
      }

      let docStatusPaid;
      const totalPaidAmount =
        (paymentType.cash ? parseCurrency(paymentAmount.cash) : 0) +
        (paymentType.transfer ? parseCurrency(paymentAmount.transfer) : 0) +
        (paymentType.cheque ? parseCurrency(paymentAmount.cheque) : 0) +
        (paymentType.credit ? parseCurrency(paymentAmount.credit) : 0) +
        (paymentType.unpaid ? parseCurrency(paymentAmount.unpaid) : 0);

      if (parseCurrency(totalPaidAmount) === 0) {
        getAlert("FAILED", "กรุณาระบุยอดการชำระเงิน");
        return;
      }

      if (paymentType.credit || paymentType.unpaid) {
        docStatusPaid = 2; // ค้างจ่าย
      } else if (parseCurrency(totalPaidAmount) < parseCurrency(grandTotal)) {
        docStatusPaid = 2; // ค้างจ่าย
      } else {
        docStatusPaid = 3; // จ่ายครบ
      }

      // ตรวจสอบช่องทางที่ถูกเลือก
      let docStatusPaidType = 6;
      const selectedMethods = Object.keys(paymentType).filter(
        (method) =>
          paymentType[method] && parseCurrency(paymentAmount[method]) > 0
      );

      if (selectedMethods.length === 1) {
        const method = selectedMethods[0];
        const paymentTypeMap = {
          cash: 1,
          transfer: 2,
          cheque: 3,
          credit: 4,
          unpaid: 5,
        };
        docStatusPaidType = paymentTypeMap[method] || 6;
      }

      await handleSubmitSo(docStatusPaid, docStatusPaidType, totalPaidAmount);
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUploadSlip = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64Image(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const checkPayment = async () => {
    const totalPaidAmount =
      (paymentType.cash ? parseCurrency(paymentAmount.cash) : 0) +
      (paymentType.transfer ? parseCurrency(paymentAmount.transfer) : 0) +
      (paymentType.cheque ? parseCurrency(paymentAmount.cheque) : 0) +
      (paymentType.credit ? parseCurrency(paymentAmount.credit) : 0) +
      (paymentType.unpaid ? parseCurrency(paymentAmount.unpaid) : 0);

    if (parseCurrency(totalPaidAmount) === 0) {
      getAlert("FAILED", "กรุณาระบุยอดการชำระเงิน");
      return;
    }

    await setShowConfirmModal(true);
  };

  // การคำนวณยอดรวม (totalPrice)
  useEffect(() => {
    const total = formDetailList.reduce(
      (acc, item) => acc + (parseCurrency(item.itemTotal) || 0),
      0
    );
    setTotalPrice(total);
  }, [formDetailList]);

  // การคำนวณส่วนลด (receiptDiscount)
  useEffect(() => {
    let discountValue = parseCurrency(formMasterList.discountValue || 0);
    let receiptDiscount = 0;

    if (selectedDiscountValueType === "2") {
      // เปอร์เซ็นต์
      receiptDiscount = (totalPrice / 100) * discountValue;
    } else if (selectedDiscountValueType === "1") {
      // จำนวนเงิน
      receiptDiscount = discountValue;
    }

    setReceiptDiscount(receiptDiscount);
  }, [totalPrice, formMasterList.discountValue, selectedDiscountValueType]);

  // การคำนวณยอดหลังหักส่วนลด (subFinal)
  useEffect(() => {
    const subFinal = totalPrice - receiptDiscount;
    setSubFinal(subFinal);
  }, [totalPrice, receiptDiscount]);

  // การคำนวณ VAT (vatAmount)
  useEffect(() => {
    const vat = isVatChecked ? subFinal * 0.07 : 0;
    setVatAmount(parseCurrency(vat.toFixed(2)));
  }, [subFinal, isVatChecked]);

  // การคำนวณยอดรวมทั้งสิ้น (grandTotal)
  useEffect(() => {
    const grandTotal = subFinal + vatAmount;
    setGrandTotal(parseCurrency(grandTotal));
  }, [subFinal, vatAmount]);

  return (
    <>
      <Breadcrumbs
        page={maxDocNo}
        isShowStatus={mode === "U"}
        statusName={statusName}
        statusColour={statusColour}
        items={[
          { name: "ขายสินค้า", url: "/sellproducts" },
          { name: name, url: "/quotation" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
        onHandleClick={() => getReport("qt", formMasterList.docNo)}
        mode={mode}
        openUploadAttach={openUploadAttach}
        setOpenUploadAttach={setOpenUploadAttach}
        showViewAttachModal={showViewAttachModal}
        setShowViewAttachModal={setShowViewAttachModal}
        selectedFiles={selectedFiles}
        selectedRecFiles={selectedRecFiles}
        setSelectedFiles={setSelectedFiles}
        handleRemoveImage={handleRemoveImage}
        handleInputFileChange={handleInputFileChange}
        handleBeforeUploadAttach={handleBeforeUploadAttach}
        urlImg={null}
        handleUploadSlip={null}
        base64Image={base64Image}
        setBase64Image={setBase64Image}
      />
      <div
        className="hidden-scrollbar"
        style={{ maxHeight: "auto", overflowY: "auto" }}
      >
        <div className="row mt-1">
          <div className="col-3">
            <DatePicker
              label="วันที่เอกสาร"
              name="docDate"
              value={formMasterList.docDate}
              onChange={(date) => handleChangeDateMaster(date, "docDate")}
              disabled={mode === "U"}
            />
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>ลูกค้า</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="arCode"
                  value={
                    (formMasterList.arCode || "") +
                    " " +
                    (formMasterList.arName || "")
                  }
                  onChange={handleChangeMaster}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleArShow}
                  disabled={disabled || formMasterList.docStatus === 13}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>
            <ArModal
              showArModal={showArModal}
              handleArClose={handleArClose}
              arDataList={arDataList}
              onRowSelectAr={onRowSelectAr}
            />
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdDate"
                value={formMasterList.createdDate}
                // onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>อ้างอิงเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="refDoc"
                value={formMasterList.refDoc || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>ที่อยู่</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="arAdd1"
                value={formMasterList.arAdd1 || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdByName"
                value={formMasterList.createdByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <DatePicker
              label="วันที่เอกสารอ้างอิง"
              name="refDocDate"
              value={formMasterList.refDocDate}
              onChange={(date) => handleChangeDateMaster(date, "refDocDate")}
              disabled={true}
            />
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList.arAdd2 || "") +
                  " " +
                  (formMasterList.arAdd3 || "")
                }
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่แก้ไขล่าสุด</label>
              <input
                // type="date"
                type="text"
                className="form-control input-spacing"
                name="updateDate"
                value={formMasterList.updateDate || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>ประเภทเอกสาร</label>
              <select
                className="form-select form-control input-spacing"
                name="docType"
                value={formMasterList.docType}
                onChange={handleChangeMaster}
                disabled={disabled || formMasterList.docStatus === 13}
              >
                {tbDocType.map((docType) => (
                  <option key={docType.DocType_Id} value={docType.DocType_Id}>
                    {docType.DocType_Name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList.arProvince || "") +
                  " " +
                  (formMasterList.arZipcode || "")
                }
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้แก้ไขเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="updateByName"
                value={formMasterList.updateByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>วิธีจัดส่ง</label>
              <select
                name="transportType"
                value={formMasterList.transportType}
                onChange={handleChangeMaster}
                className="form-select form-control input-spacing"
                disabled={disabled || formMasterList.docStatus === 13}
              >
                {tbTransType.map((transType) => (
                  <option
                    key={transType.Trans_TypeID}
                    value={transType.Trans_TypeID}
                  >
                    {transType.Trans_TypeName}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>เลขที่ภาษี</label>
              <input
                type="text"
                className="form-control input-spacing"
                value={formMasterList.arTaxNo || ""}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3" />
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <DatePicker
              label="Due Date"
              name="docDueDate"
              value={formMasterList.docDueDate}
              onChange={(date) => handleChangeDateMaster(date, "docDueDate")}
              disabled={disabled || formMasterList.docStatus === 13}
            />
          </div>
          <div className="col-6" />
          <div className="col-3" />
        </div>
        <div className="row mt-1">
          <div className="col-3" />
          <div className="col-6" />
          <div className="col-3" />
        </div>
        <hr />
        <div className="row mt-2">
          <div className="col-6">
            <div className="d-flex align-items-center">
              <label>รายละเอียดเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="docRemark1"
                value={formMasterList.docRemark1 || ""}
                onChange={handleChangeMaster}
                maxLength={100}
                disabled={disabled || formMasterList.docStatus === 13}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="d-flex align-items-center">
              <label>หมายเหตุธุรการ</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="docRemark2"
                value={formMasterList.docRemark2 || ""}
                onChange={handleChangeMaster}
                maxLength={500}
                disabled={disabled || formMasterList.docStatus === 13}
              />
            </div>
          </div>
        </div>
        <div className="row mt-2">
          <ItemTable
            formDetailList={formDetailList}
            handleChangeDetail={handleChangeDetail}
            handleDuplicateRow={handleDuplicateRow}
            handleRemoveRow={handleRemoveRow}
            formatCurrency={formatCurrency}
            showItemModal={showItemModal}
            handleItemClose={handleItemClose}
            itemDataList={itemDataList}
            onRowSelectItem={onRowSelectItem}
            handleItemShow={handleItemShow}
            whDataList={whDataList}
            handleFocus={handleFocus}
            handleBlur={handleBlur}
            disabled={disabled || formMasterList.docStatus === 13}
            isQuotation={true}
          />
          <Summary
            formMasterList={formMasterList}
            handleChangeMaster={handleChangeMaster}
            selectedDiscountValueType={selectedDiscountValueType}
            handleCheckboxChange={handleCheckboxChange}
            receiptDiscount={receiptDiscount}
            formatCurrency={formatCurrency}
            totalPrice={totalPrice}
            subFinal={subFinal}
            isVatChecked={isVatChecked}
            handleVatChange={handleVatChange}
            vatAmount={vatAmount}
            grandTotal={grandTotal}
            disabled={disabled || formMasterList.docStatus === 13}
          />
          <PaymentModal
            mode={mode}
            show={showPayTypeModal}
            grandTotal={grandTotal}
            paymentType={paymentType}
            setPaymentType={setPaymentType}
            paymentAmount={paymentAmount}
            setPaymentAmount={setPaymentAmount}
            payDatetime={payDatetime}
            setPayDatetime={setPayDatetime}
            handlePayTypeClose={handlePayTypeClose}
            handleUpdatePayment={handleUpdatePayment}
            handleUploadSlip={handleUploadSlip}
            base64Image={base64Image}
            setBase64Image={setBase64Image}
            chequeNo={chequeNo}
            setChequeNo={setChequeNo}
            chequeName={chequeName}
            setChequeName={setChequeName}
            chequeBranch={chequeBranch}
            setChequeBranch={setChequeBranch}
            chequeDate={chequeDate}
            setChequeDate={setChequeDate}
            bankMasterId={bankMasterId}
            setBankMasterId={setBankMasterId}
            bankId={bankId}
            setBankId={setBankId}
            bankInputMode={bankInputMode}
            setBankInputMode={setBankInputMode}
            payToAccNo={payToAccNo}
            setPayToAccNo={setPayToAccNo}
            payToAccName={payToAccName}
            setPayToAccName={setPayToAccName}
            showConfirmModal={showConfirmModal}
            setShowConfirmModal={setShowConfirmModal}
            checkPayment={checkPayment}
            isAllowCredit={false}
            docId={formMasterList.docId}
            docCodeId={1}
            multipleSlipImages={multipleSlipImages}
            setMultipleSlipImages={setMultipleSlipImages}
            handleMultipleSlipUpload={handleMultipleSlipUpload}
            handleRemoveSlipImage={handleRemoveSlipImage}
            handleClearAllSlips={handleClearAllSlips}
            isUploadingSlips={isUploadingSlips}
          />
        </div>
      </div>
      <br />
      <FormAction
        onSubmit={handleSubmit}
        onUpdate={handleUpdate}
        onCancel={handleCancel}
        onApprovedPay={handlePayTypeShow}
        onViewSo={() => setShowViewSoModal(true)}
        mode={mode}
        setMode={setMode}
        disabled={formMasterList.docStatus === 13}
        docStatus={docStatus}
        soNo={soNo}
        footer={true}
      />
      {showViewSoModal && soNo && (
        <ViewSoModal
          showViewSoModal={showViewSoModal}
          handleViewSoClose={handleViewSoClose}
          mode={mode}
          name={`ใบขายสินค้าเลขที่ ${soNo}`}
          maxDocNo={soNo}
        />
      )}

      {/* Confirm Modal */}
      <div
        className={`modal fade ${showConfirmModal ? "show" : ""}`}
        tabIndex="-1"
        style={{ display: showConfirmModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title fw-bold">ยืนยันการชำระเงิน</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowConfirmModal(false)}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>คุณแน่ใจว่าต้องการยืนยันการชำระเงิน{name}หรือไม่?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-lg w-25 shadow text-white d-flex align-items-center justify-content-center"
                style={{ backgroundColor: "#EF6C00", fontSize: "16px" }}
                onClick={async () => {
                  setShowConfirmModal(false);
                  await handleUpdatePayment();
                }}
              >
                ยืนยัน
              </button>
              <button
                type="button"
                className="btn btn-lg w-25 shadow text-white"
                style={{ backgroundColor: "red", fontSize: "16px" }}
                onClick={() => setShowConfirmModal(false)}
              >
                ยกเลิก
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Form;
